<section class="review">
  <div class="review-heading">
    <h4>{{ 'software_override.review.title' | translate }}</h4>
    <p>{{ 'software_override.review.description' | translate }}</p>
  </div>

  <app-effective-software-selection
    class="effective-selection-review"
    [resolutions]="softwareSelectionResolutions"
    [supportedProjectIds]="supportedProjectIds"
    [forLicenseBatch]="forLicenseBatch"
  ></app-effective-software-selection>

  <section class="review-group" aria-labelledby="bundle-review-title">
    <div class="review-group-heading">
      <h5 id="bundle-review-title">
        {{ 'software_override.bundle.title' | translate }}
      </h5>
      <span>
        {{
          'software_override.count.selected'
            | translate: { count: selectedBundles.length }
        }}
      </span>
    </div>

    @if (selectedBundles.length === 0) {
      <div class="empty-state">
        {{ 'software_override.review.no_bundle_overrides' | translate }}
      </div>
    } @else {
      <div class="review-grid">
        @for (selection of selectedBundles; track selection.bundle.id) {
          <article class="review-card">
            <div class="card-heading">
              <div>
                <span>{{
                  'software_override.labels.release' | translate
                }}</span>
                <h6>
                  {{
                    selection.release?.name ||
                      ('software_override.labels.release_bundle' | translate)
                  }}
                </h6>
              </div>
              <span class="status">{{ selection.bundle.archiveStatus }}</span>
            </div>

            <div class="bundle-name">
              <span>{{ 'software_override.labels.bundle' | translate }}</span>
              <strong>{{
                selection.bundle.name || selection.bundle.id
              }}</strong>
              @if (isUnresolved(selection.bundle.id)) {
                <span class="status">{{
                  'software_override.unresolved.label' | translate
                }}</span>
              }
            </div>

            @if (getRelevantBundleArtifacts(selection.bundle).length > 0) {
              <div class="project-list">
                <span>{{
                  'software_override.bundle.included_projects' | translate
                }}</span>
                <ul>
                  @for (
                    artifact of getRelevantBundleArtifacts(selection.bundle);
                    track artifact.id
                  ) {
                    <li>
                      <span>{{
                        artifact.projectName || artifact.projectId
                      }}</span>
                      <strong>{{ artifact.version }}</strong>
                    </li>
                  }
                </ul>
              </div>
            }

            @if (getOtherBundleArtifacts(selection.bundle); as otherArtifacts) {
              @if (otherArtifacts.length > 0) {
                <details class="other-project-list">
                  <summary>
                    <span>{{
                      'software_override.bundle.other_projects' | translate
                    }}</span>
                    <span>{{ otherArtifacts.length }}</span>
                  </summary>
                  <ul>
                    @for (artifact of otherArtifacts; track artifact.id) {
                      <li>
                        <span>{{
                          artifact.projectName || artifact.projectId
                        }}</span>
                        <strong>{{ artifact.version }}</strong>
                      </li>
                    }
                  </ul>
                </details>
              }
            }
          </article>
        }
      </div>
    }
  </section>

  <section class="review-group" aria-labelledby="artifact-review-title">
    <div class="review-group-heading">
      <h5 id="artifact-review-title">
        {{ 'software_override.artifact.title' | translate }}
      </h5>
      <span>
        {{
          'software_override.count.selected'
            | translate: { count: selectedArtifacts.length }
        }}
      </span>
    </div>

    @if (selectedArtifacts.length === 0) {
      <div class="empty-state">
        {{ 'software_override.review.no_artifact_overrides' | translate }}
      </div>
    } @else {
      <div class="review-grid">
        @for (artifact of selectedArtifacts; track artifact.id) {
          <article class="review-card artifact-card">
            <div class="card-heading">
              <div>
                <span>{{
                  'software_override.labels.project' | translate
                }}</span>
                <h6>{{ artifact.projectName || artifact.projectId }}</h6>
              </div>
              <strong class="version">{{
                isUnresolved(artifact.id)
                  ? ('software_override.unresolved.label' | translate)
                  : artifact.version
              }}</strong>
            </div>

            @if (artifact.description) {
              <p>{{ artifact.description }}</p>
            }

            <div class="metadata">
              @if (artifact.artifactMaturity) {
                <span>{{ artifact.artifactMaturity }}</span>
              }
              @for (scope of artifact.scopes; track scope) {
                <span>{{ scope }}</span>
              }
            </div>
          </article>
        }
      </div>
    }
  </section>
</section>
